// Helpers for the server-side premium subscription (Midtrans).

// Load the Midtrans Snap.js script once, using the client key from checkout.
// Sandbox keys start with "SB-"; production keys do not.
let _snapLoading = null;
export function loadSnap(clientKey) {
  if (typeof window !== "undefined" && window.snap) return Promise.resolve(window.snap);
  if (_snapLoading) return _snapLoading;
  const isSandbox = String(clientKey || "").startsWith("SB-");
  const src = isSandbox
    ? "https://app.sandbox.midtrans.com/snap/snap.js"
    : "https://app.midtrans.com/snap/snap.js";
  _snapLoading = new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = src;
    el.setAttribute("data-client-key", clientKey || "");
    el.onload = () => resolve(window.snap);
    el.onerror = () => {
      _snapLoading = null;
      reject(new Error("Gagal memuat halaman pembayaran."));
    };
    document.body.appendChild(el);
  });
  return _snapLoading;
}

const DAY = 86400000;

// Human label for the active-until date with near-expiry states.
export function subscriptionLabel(untilMs, now, formatDate) {
  if (!untilMs) return null;
  const n = typeof now === "number" ? now : Date.now();
  if (untilMs <= n) return "Masa langganan telah berakhir.";
  const daysLeft = Math.ceil((untilMs - n) / DAY);
  if (daysLeft <= 0) return "Langganan berakhir hari ini.";
  if (daysLeft === 1) return "Langganan berakhir besok.";
  return `Langganan aktif hingga ${formatDate(untilMs)}`;
}
